export default __webpack_public_path__ + "static/media/vincent.7cd70b1a.jpg";